var _path, _mask, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgUpload = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.604 9.0489L17.3948 8.1489C17.6144 7.9005 17.5892 7.5201 17.3396 7.3017L12.596 3.1485C12.3692 2.9505 12.032 2.9505 11.8052 3.1485L7.0604 7.3017C6.8108 7.5201 6.7856 7.9005 7.0052 8.1501L7.796 9.0489C8.0156 9.2973 8.3936 9.3213 8.642 9.1041L11 7.0377V15.5997C11 15.9309 11.2688 16.1997 11.6 16.1997H12.8C13.1312 16.1997 13.4 15.9309 13.4 15.5997V7.0377L15.758 9.1041C16.0076 9.3213 16.3856 9.2973 16.604 9.0489ZM5.6 18.6H18.8C19.1312 18.6 19.4 18.8688 19.4 19.2V20.4C19.4 20.7312 19.1312 21 18.8 21H5.6C5.2688 21 5 20.7312 5 20.4V19.2C5 18.8688 5.2688 18.6 5.6 18.6Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 3,
    width: 15,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.604 9.0489L17.3948 8.1489C17.6144 7.9005 17.5892 7.5201 17.3396 7.3017L12.596 3.1485C12.3692 2.9505 12.032 2.9505 11.8052 3.1485L7.0604 7.3017C6.8108 7.5201 6.7856 7.9005 7.0052 8.1501L7.796 9.0489C8.0156 9.2973 8.3936 9.3213 8.642 9.1041L11 7.0377V15.5997C11 15.9309 11.2688 16.1997 11.6 16.1997H12.8C13.1312 16.1997 13.4 15.9309 13.4 15.5997V7.0377L15.758 9.1041C16.0076 9.3213 16.3856 9.2973 16.604 9.0489ZM5.6 18.6H18.8C19.1312 18.6 19.4 18.8688 19.4 19.2V20.4C19.4 20.7312 19.1312 21 18.8 21H5.6C5.2688 21 5 20.7312 5 20.4V19.2C5 18.8688 5.2688 18.6 5.6 18.6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(1 0 0 -1 0 24)",
    fill: "#9CA4B5"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUpload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/upload.66484d0f.svg";
export { ForwardRef as ReactComponent };